/**
 * Österreichische Steuernummer (Abgabenkontonummer) — Vorgang 018.
 *
 * Neun Ziffern: historisch zweistellige Finanzamtsnummer + siebenstellige
 * Steuernummer. Seit der Finanzämter-Zusammenlegung (01.01.2021) wird die
 * Finanzamts-Deutung nicht mehr vorgenommen; die Nummer bleibt neunstellig.
 *
 * BEWUSST KEINE PRÜFZIFFERNRECHNUNG (ADR 018, F10): der historische Algorithmus
 * ist amtlich nicht für Dritte spezifiziert und seit 2021 nicht verlässlich —
 * eine selbstgebaute Prüfziffer, die gültige Nummern abweist, wäre teurer als
 * gar keine. fiskaltrust prüft selbst nur das Format, kein Register. Die
 * Richtigkeit sichert die ausdrückliche Kundenbestätigung (AK9), nicht die
 * Mathematik.
 *
 * Rein, ohne React, ohne Beträge. Gespeichert wird normalisiert (neun Ziffern,
 * als text — führende Nullen sind bedeutsam), angezeigt `XX-XXX/XXXX`.
 */

/**
 * Entfernt die üblichen Trennzeichen — Leerzeichen, `-`, `/` — und sonst NICHTS.
 *
 * Absichtlich nicht „alle Nicht-Ziffern": eine Normalisierung, die Buchstaben
 * stillschweigend löscht, machte aus einem Tippfehler eine gültig aussehende
 * Nummer — und eine falsche Nummer ist der teuerste vorhersehbare Supportfall
 * dieses Moduls (Zertifikatstausch über den fiskaltrust-Support). Was nach dem
 * Entfernen der Trennzeichen keine neun ASCII-Ziffern sind, weist `istGueltig`
 * ab, statt es zurechtzubiegen.
 */
export function normalisieren(eingabe: string): string {
  return eingabe.replace(/[\s\-/]/g, '')
}

/**
 * Gültig ist, was nach Entfernen der Trennzeichen aus genau neun ASCII-Ziffern
 * besteht (ADR 018). Unicode-Ziffern anderer Schriften zählen nicht — `[0-9]`,
 * nicht `\d` mit Unicode-Flag, ist hier die Aussage, nicht eine Nachlässigkeit.
 */
export function istGueltig(eingabe: string): boolean {
  return /^[0-9]{9}$/.test(normalisieren(eingabe))
}

/**
 * Anzeigeform `XX-XXX/XXXX`. Was (noch) keine gültige Nummer ist, kommt
 * unverändert zurück — das Feld zeigt beim Tippen die Eingabe, nicht einen
 * halbfertigen Umbau.
 */
export function formatieren(eingabe: string): string {
  const n = normalisieren(eingabe)
  if (!/^[0-9]{9}$/.test(n)) return eingabe
  return `${n.slice(0, 2)}-${n.slice(2, 5)}/${n.slice(5, 9)}`
}
